/**
 * Masternodes subpage that is used for `pages/wallet.jsx`.
 *
 * <i>Copyright (c) 2019 Energi Cryptocurrency - https://energi.world</i><br>
 * Proprietary License
 *
 *
 * @module components/subpages/wallet.jsx
 * @class SubPageWallet
 * @since 0.0.1
*/


import React from 'react';
import {Line} from 'react-chartjs-2';
import {useStore} from 'effector-react';
import blockPolling from '../../globals/block-polling';
import formatNumber from '../../lib/helpers/number-format';
import translations from '../../lib/translations';

const PRIMARY_COLOR = 'rgba(103, 112, 116, 0.8)',
    SECONDARY_COLOR = '#263238',
    FONT_COLOR = '#bdbdbd';

const DifficultyChart = props => {
    let data, options, label, difficulty, lastDifficultyMsg;
    const difficulties = useStore(blockPolling.$difficulties),
        translate = translations.init(props),
        locales = props.langInfo && props.langInfo.locales,
        lastDifficulty = difficulties[0] && difficulties[0].difficulty,
        // we need an immutable array: cannot use Array.reverse()
        dataset = difficulties.reduce((cumm, item) => {
            cumm.unshift(item);
            return cumm;
        }, []);

    label = dataset.map(item => item.block);
    difficulty = dataset.map(item => item.difficulty);

    data = {
        labels: label,
        datasets: [
            {
                label: 'Difficulty',
                fill: true,
                lineTension: 0.1,
                backgroundColor: PRIMARY_COLOR,
                borderColor: SECONDARY_COLOR,
                borderWidth: '1',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: SECONDARY_COLOR,
                pointBackgroundColor: '#fff',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: SECONDARY_COLOR,
                pointHoverBorderColor: SECONDARY_COLOR,
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: difficulty
            }
        ]
    };

    options = {
        animation: false,
        tooltips: {
            callbacks: {
                title: function() {},
                label: function(tooltipItem) {
                    return formatNumber(locales, tooltipItem.yLabel, 0, false, false, 2);
                }
            }
        },
        scales: {
            xAxes: [{
                ticks: {
                    autoSkip: true,
                    fontColor: FONT_COLOR,
                    fontSize: 10,
                    maxTicksLimit: 10
                },
                scaleLabel: {
                    display: true,
                    labelString: 'Block',
                    fontColor: FONT_COLOR,
                    fontSize: 12,
                }
            }],
            yAxes: [{
                ticks: {
                    callback: function(label) {
                        return formatNumber(locales, label, 0, false, true, 2);
                    },
                    fontColor: FONT_COLOR,
                    fontSize: 10
                },
            }]
        },
        legend: {
            display: false,
        }
    };

    if (lastDifficulty) {
        lastDifficultyMsg = formatNumber(locales, lastDifficulty, 1, false, true, 3);
    }

    return (
        <div className="difficulty-chart">
            <div className="header">
                <p>{translate.t('DIFFICULTY', true)}</p>
            </div>
            <p>{lastDifficultyMsg}</p>
            <Line
                data={data}
                options={options}
                redraw={true} />
        </div>
    );
};

export default DifficultyChart;
